/* eslint-disable no-magic-numbers */

/**
 * The used values for matchMedia must be the same defined in the following file:
 * packages/ui-components/src/ui-styles/sass/utilities/responsiveness-mixins.scss
 */
const uiGap = 32;
const uiTablet = 768;
const uiDesktop = 960 + (2 * uiGap);
const uiWideScreen= 1152 + (2 * uiGap);
const uiTabletUnitLess = uiTablet - 1;
const uiDesktopUnitLess = uiDesktop - 1;
const uiWideScreenUnitLess = uiWideScreen - 1;

const mobileOnlyScreen = window.matchMedia(`screen and (max-width: ${uiTabletUnitLess}px)`);
const tabletScreen = window.matchMedia(`screen and (min-width: ${uiTablet}px), print`);
const tabletOnlyScreen = window.matchMedia(`screen and (min-width: ${uiTablet}px) and (max-width: ${uiDesktopUnitLess}px)`);
const touchScreen = window.matchMedia(`screen and (max-width: ${uiDesktopUnitLess}px)`);
const desktopScreen = window.matchMedia(`screen and (min-width: ${uiDesktop}px)`);
const desktopOnlyScreen = window.matchMedia(`screen and (min-width: ${uiDesktop}px) and (max-width: ${uiWideScreenUnitLess}px)`);
const wideScreen = window.matchMedia(`screen and (min-width: ${uiWideScreen}px)`);

/** Window Size (WS) methods */
export const isMobileWindowSize = () => mobileOnlyScreen.matches;
export const isTabletWindowSize = () => tabletScreen.matches;
export const isTabletOnlyWindowSize = () => tabletOnlyScreen.matches;
export const isMobileOrTabletWindowSize = () => touchScreen.matches;
export const isDesktopWindowSize = () => desktopScreen.matches;
export const isDesktopOnlyWindowSize = () => desktopOnlyScreen.matches;
export const isWideScreenWindowSize = () => wideScreen.matches;

/** Device methods */
export const isBrowser = () => typeof window !== 'undefined';
export const iOS = isBrowser() && /iPad|iPhone|iPod/.test(navigator.userAgent);
